import { applyMiddleware, createStore, compose } from "redux";
import promise from "redux-promise";
import multi from "redux-multi";
import thunk from "redux-thunk";

import rootReducer from "./reducers/reducers";

export const configureStore = () => {
  try {
    const persistedState = {};

    // Debug pela extensão redux-devtools-extension do Chrome
    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const store = createStore(
      rootReducer,
      // () => {},
      persistedState,
      composeEnhancers(applyMiddleware(multi, thunk, promise))
    );

    return store;
  } catch (error) {
    //alert(error)
  }
};

export const store = configureStore();



// WEBPACK FOOTER //
// ./src/config.js